import { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { img, altOf } from "@/lib/media";
import { useLang } from "@/lib/i18n";
import { GalleryVideo } from "./GalleryVideo";

export const Lightbox = ({ items, index, setIndex, onClose }) => {
  const { t, lang } = useLang();
  const n = items.length;
  const item = items[index];
  const touch = useRef(null);
  const closeRef = useRef(null);
  const go = (d) => setIndex((index + d + n) % n);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setIndex((i) => (i + 1) % n);
      if (e.key === "ArrowLeft") setIndex((i) => (i - 1 + n) % n);
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.__lenis?.stop();
    window.addEventListener("keydown", onKey);
    closeRef.current?.focus();
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = prev; window.__lenis?.start(); };
  }, [n, onClose, setIndex]);

  const onTouchEnd = (e) => {
    if (touch.current === null) return;
    const dx = e.changedTouches[0].clientX - touch.current;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    touch.current = null;
  };

  const small = item.low_resolution;
  return (
    <div className="lb" role="dialog" aria-modal="true" aria-label={t.lb.viewer} data-testid="lightbox"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }} onTouchEnd={onTouchEnd}>
      <button type="button" className="lb-nav prev" aria-label={t.lb.prev} onClick={() => go(-1)} data-testid="lightbox-prev"><ChevronLeft size={30} /></button>
      <figure className="lb-fig">
        {item.type === "video" ? (
          <GalleryVideo key={item.file} item={item} alt={altOf(item, lang)} className="lb-media" posterWidth={1600} />
        ) : (
        <img key={item.file} src={img(item.file, small ? 960 : 1600)} alt={altOf(item, lang)} data-testid="lightbox-image"
          className={small ? "lb-small" : undefined} />)}
        <figcaption data-testid="lightbox-caption">{altOf(item, lang)}<span className="lb-count">{index + 1} / {n}</span></figcaption>
        <button ref={closeRef} type="button" className="btn" onClick={onClose} data-testid="lightbox-close">{t.lb.close}</button>
      </figure>
      <button type="button" className="lb-nav next" aria-label={t.lb.next} onClick={() => go(1)} data-testid="lightbox-next"><ChevronRight size={30} /></button>
    </div>
  );
};
